import { defu } from 'defu';
import axios from 'axios';
import MD5 from 'md5';
import { defineComponent, reactive, h, createApp } from 'vue-demi';
import dayjs from 'dayjs';
import { v1 } from 'uuid';
import { createStorage } from 'unstorage-es5';
import localStorageDriver from 'unstorage-es5/drivers/localstorage';

const VerifyDialogStyle = "*,::before,::after{--un-rotate:0;--un-rotate-x:0;--un-rotate-y:0;--un-rotate-z:0;--un-scale-x:1;--un-scale-y:1;--un-scale-z:1;--un-skew-x:0;--un-skew-y:0;--un-translate-x:0;--un-translate-y:0;--un-translate-z:0;--un-pan-x: ;--un-pan-y: ;--un-pinch-zoom: ;--un-scroll-snap-strictness:proximity;--un-ordinal: ;--un-slashed-zero: ;--un-numeric-figure: ;--un-numeric-spacing: ;--un-numeric-fraction: ;--un-border-spacing-x:0;--un-border-spacing-y:0;--un-ring-offset-shadow:0 0 rgb(0 0 0 / 0);--un-ring-shadow:0 0 rgb(0 0 0 / 0);--un-shadow-inset: ;--un-shadow:0 0 rgb(0 0 0 / 0);--un-ring-inset: ;--un-ring-offset-width:0px;--un-ring-offset-color:#fff;--un-ring-width:0px;--un-ring-color:rgb(147 197 253 / 0.5);--un-blur: ;--un-brightness: ;--un-contrast: ;--un-drop-shadow: ;--un-grayscale: ;--un-hue-rotate: ;--un-invert: ;--un-saturate: ;--un-sepia: ;--un-backdrop-blur: ;--un-backdrop-brightness: ;--un-backdrop-contrast: ;--un-backdrop-grayscale: ;--un-backdrop-hue-rotate: ;--un-backdrop-invert: ;--un-backdrop-opacity: ;--un-backdrop-saturate: ;--un-backdrop-sepia: ;}::backdrop{--un-rotate:0;--un-rotate-x:0;--un-rotate-y:0;--un-rotate-z:0;--un-scale-x:1;--un-scale-y:1;--un-scale-z:1;--un-skew-x:0;--un-skew-y:0;--un-translate-x:0;--un-translate-y:0;--un-translate-z:0;--un-pan-x: ;--un-pan-y: ;--un-pinch-zoom: ;--un-scroll-snap-strictness:proximity;--un-ordinal: ;--un-slashed-zero: ;--un-numeric-figure: ;--un-numeric-spacing: ;--un-numeric-fraction: ;--un-border-spacing-x:0;--un-border-spacing-y:0;--un-ring-offset-shadow:0 0 rgb(0 0 0 / 0);--un-ring-shadow:0 0 rgb(0 0 0 / 0);--un-shadow-inset: ;--un-shadow:0 0 rgb(0 0 0 / 0);--un-ring-inset: ;--un-ring-offset-width:0px;--un-ring-offset-color:#fff;--un-ring-width:0px;--un-ring-color:rgb(147 197 253 / 0.5);--un-blur: ;--un-brightness: ;--un-contrast: ;--un-drop-shadow: ;--un-grayscale: ;--un-hue-rotate: ;--un-invert: ;--un-saturate: ;--un-sepia: ;--un-backdrop-blur: ;--un-backdrop-brightness: ;--un-backdrop-contrast: ;--un-backdrop-grayscale: ;--un-backdrop-hue-rotate: ;--un-backdrop-invert: ;--un-backdrop-opacity: ;--un-backdrop-saturate: ;--un-backdrop-sepia: ;}.absolute{position:absolute;}.fixed{position:fixed;}.relative{position:relative;}.bottom-0{bottom:0;}.left-0{left:0;}.left-1\\/2{left:50%;}.right-0{right:0;}.right-10px{right:10px;}.top-0{top:0;}.top-1\\/2{top:50%;}.top-10px{top:10px;}.z-1000{z-index:1000;}.m-0{margin:0;}.mb-15px{margin-bottom:15px;}.mb-20px{margin-bottom:20px;}.mb-30px{margin-bottom:30px;}.mb-4px{margin-bottom:4px;}.mr-14px{margin-right:14px;}.mr-2px{margin-right:2px;}.mr-6px{margin-right:6px;}.box-border{box-sizing:border-box;}.block{display:block;}.h-35px{height:35px;}.h-40px{height:40px;}.h-44px{height:44px;}.h-full{height:100%;}.max-w-320px{max-width:320px;}.w-105px{width:105px;}.w-110px{width:110px;}.w-full{width:100%;}.flex{display:flex;}.flex-1{flex:1 1 0%;}.flex-wrap{flex-wrap:wrap;}.-translate-x-1\\/2{--un-translate-x:-50%;transform:translateX(var(--un-translate-x)) translateY(var(--un-translate-y)) translateZ(var(--un-translate-z)) rotate(var(--un-rotate)) rotateX(var(--un-rotate-x)) rotateY(var(--un-rotate-y)) rotateZ(var(--un-rotate-z)) skewX(var(--un-skew-x)) skewY(var(--un-skew-y)) scaleX(var(--un-scale-x)) scaleY(var(--un-scale-y)) scaleZ(var(--un-scale-z));}.-translate-y-1\\/2{--un-translate-y:-50%;transform:translateX(var(--un-translate-x)) translateY(var(--un-translate-y)) translateZ(var(--un-translate-z)) rotate(var(--un-rotate)) rotateX(var(--un-rotate-x)) rotateY(var(--un-rotate-y)) rotateZ(var(--un-rotate-z)) skewX(var(--un-skew-x)) skewY(var(--un-skew-y)) scaleX(var(--un-scale-x)) scaleY(var(--un-scale-y)) scaleZ(var(--un-scale-z));}.transform{transform:translateX(var(--un-translate-x)) translateY(var(--un-translate-y)) translateZ(var(--un-translate-z)) rotate(var(--un-rotate)) rotateX(var(--un-rotate-x)) rotateY(var(--un-rotate-y)) rotateZ(var(--un-rotate-z)) skewX(var(--un-skew-x)) skewY(var(--un-skew-y)) scaleX(var(--un-scale-x)) scaleY(var(--un-scale-y)) scaleZ(var(--un-scale-z));}.cursor-pointer{cursor:pointer;}.items-center{align-items:center;}.justify-center{justify-content:center;}.overflow-hidden{overflow:hidden;}.border-0\\.5px{border-width:0.5px;}.border-r{border-right-width:1px;}.border-t{border-top-width:1px;}.border-\\[rgba\\(0\\,0\\,0\\,0\\.20\\)\\]{--un-border-opacity:0.20;border-color:rgba(0, 0, 0, var(--un-border-opacity));}.border-r-\\[rgba\\(0\\,0\\,0\\,0\\.15\\)\\]{--un-border-opacity:0.15;--un-border-right-opacity:var(--un-border-opacity);border-right-color:rgba(0, 0, 0, var(--un-border-right-opacity));}.border-t-\\[rgba\\(0\\,0\\,0\\,0\\.15\\)\\]{--un-border-opacity:0.15;--un-border-top-opacity:var(--un-border-opacity);border-top-color:rgba(0, 0, 0, var(--un-border-top-opacity));}.rounded-12px{border-radius:12px;}.rounded-3\\.5px{border-radius:3.5px;}.rounded-8px{border-radius:8px;}.border-none{border-style:none;}.border-solid{border-style:solid;}.bg-black{--un-bg-opacity:1;background-color:rgb(0 0 0 / var(--un-bg-opacity));}.bg-white{--un-bg-opacity:1;background-color:rgb(255 255 255 / var(--un-bg-opacity));}.bg-opacity-70{--un-bg-opacity:0.7;}.p-0{padding:0;}.px-16px{padding-left:16px;padding-right:16px;}.px-2{padding-left:0.5rem;padding-right:0.5rem;}.px-8px{padding-left:8px;padding-right:8px;}.pt{padding-top:1rem;}.pt-22px{padding-top:22px;}.text-center{text-align:center;}.text-12px{font-size:12px;}.text-14px{font-size:14px;}.text-16px{font-size:16px;}.text-20px{font-size:20px;}.text-24px{font-size:24px;}.text-\\#009DE4{--un-text-opacity:1;color:rgb(0 157 228 / var(--un-text-opacity));}.text-\\#212121{--un-text-opacity:1;color:rgb(33 33 33 / var(--un-text-opacity));}.text-\\#333{--un-text-opacity:1;color:rgb(51 51 51 / var(--un-text-opacity));}.text-\\#666{--un-text-opacity:1;color:rgb(102 102 102 / var(--un-text-opacity));}.text-\\#999999{--un-text-opacity:1;color:rgb(153 153 153 / var(--un-text-opacity));}.text-\\#FE5B00{--un-text-opacity:1;color:rgb(254 91 0 / var(--un-text-opacity));}.text-\\#FE9129{--un-text-opacity:1;color:rgb(254 145 41 / var(--un-text-opacity));}.text-white{--un-text-opacity:1;color:rgb(255 255 255 / var(--un-text-opacity));}.leading-18px{line-height:18px;}.leading-20px{line-height:20px;}.leading-21px{line-height:21px;}.opacity-0{opacity:0;}.outline-none{outline:2px solid transparent;outline-offset:2px;}.duration-300{transition-duration:300ms;}.ease-in{transition-timing-function:cubic-bezier(0.4, 0, 1, 1);}.ease-out{transition-timing-function:cubic-bezier(0, 0, 0.2, 1);}.placeholder-\\#999::placeholder{--un-placeholder-opacity:1;color:rgb(153 153 153 / var(--un-placeholder-opacity));}";

const en = {
  step_up_authentication: "Step-up authentication",
  this_operation_is_at_risk_and_requires_authentication: "This operation is at risk and requires authentication",
  please_enter_the_answer: "Please enter the answer",
  refresh: "Refresh",
  submit: "Submit",
  cancel: "Cancel"
};

const ar = {
  step_up_authentication: "\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0623\u0645\u0627\u0646",
  this_operation_is_at_risk_and_requires_authentication: "\u0647\u0630\u0647 \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0645\u062D\u0641\u0648\u0641\u0629 \u0628\u0627\u0644\u0645\u062E\u0627\u0637\u0631 \u0648\u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0623\u0645\u0627\u0646",
  please_enter_the_answer: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  refresh: "\u062A\u062D\u062F\u064A\u062B",
  submit: "\u0625\u0631\u0633\u0627\u0644",
  cancel: "\u0625\u0644\u063A\u0627\u0621"
};

const de = {
  step_up_authentication: "Sicherheits\xFCberpr\xFCfung",
  this_operation_is_at_risk_and_requires_authentication: "Diese Operation ist riskant und erfordert eine Sicherheits\xFCberpr\xFCfung",
  please_enter_the_answer: "Bitte geben Sie die Antwort ein",
  refresh: "Aktualisieren",
  submit: "Abschicken",
  cancel: "Abbrechen"
};

const es = {
  step_up_authentication: "Verificaci\xF3n de seguridad",
  this_operation_is_at_risk_and_requires_authentication: "Esta operaci\xF3n es riesgosa y requiere verificaci\xF3n de seguridad",
  please_enter_the_answer: "Por favor, ingresa la respuesta",
  refresh: "Refrescar",
  submit: "Enviar",
  cancel: "Cancelar"
};

const fr = {
  step_up_authentication: "V\xE9rification de s\xE9curit\xE9",
  this_operation_is_at_risk_and_requires_authentication: "Cette op\xE9ration est risqu\xE9e et n\xE9cessite une v\xE9rification de s\xE9curit\xE9",
  please_enter_the_answer: "Veuillez entrer la r\xE9ponse",
  refresh: "Actualiser",
  submit: "Soumettre",
  cancel: "Annuler"
};

const id = {
  step_up_authentication: "Verifikasi Keamanan",
  this_operation_is_at_risk_and_requires_authentication: "Operasi ini berisiko dan memerlukan verifikasi keamanan",
  please_enter_the_answer: "Mohon masukkan jawaban",
  refresh: "Segarkan",
  submit: "Kirim",
  cancel: "Batalkan"
};

const ja = {
  step_up_authentication: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u78BA\u8A8D",
  this_operation_is_at_risk_and_requires_authentication: "\u3053\u306E\u64CD\u4F5C\u306B\u306F\u30EA\u30B9\u30AF\u304C\u4F34\u3046\u305F\u3081\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u78BA\u8A8D\u304C\u5FC5\u8981\u3067\u3042\u308B",
  please_enter_the_answer: "\u7B54\u3048\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  refresh: "\u66F4\u65B0",
  submit: "\u63D0\u51FA",
  cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB"
};

const ko = {
  step_up_authentication: "\uBCF4\uC548 \uC778\uC99D",
  this_operation_is_at_risk_and_requires_authentication: "\uC774 \uC791\uC5C5\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uBCF4\uC548 \uC778\uC99D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
  please_enter_the_answer: "\uB2F5\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
  refresh: "\uC0C8\uB85C\uACE0\uCE68",
  submit: "\uC81C\uCD9C",
  cancel: "\uCDE8\uC18C"
};

const pt = {
  step_up_authentication: "Verifica\xE7\xE3o de Seguran\xE7a",
  this_operation_is_at_risk_and_requires_authentication: "A opera\xE7\xE3o \xE9 arriscada e requer uma verifica\xE7\xE3o de seguran\xE7a",
  please_enter_the_answer: "Por favor, insira a resposta",
  refresh: "Atualizar",
  submit: "Enviar",
  cancel: "Cancelar"
};

const ru = {
  step_up_authentication: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438",
  this_operation_is_at_risk_and_requires_authentication: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u0430. \u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438.",
  please_enter_the_answer: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442",
  refresh: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
  submit: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
  cancel: "\u041E\u0442\u043C\u0435\u043D\u0430"
};

const th = {
  step_up_authentication: "\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
  this_operation_is_at_risk_and_requires_authentication: "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E48\u0E22\u0E07 \u0E15\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22",
  please_enter_the_answer: "\u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E33\u0E15\u0E2D\u0E1A",
  refresh: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
  submit: "\u0E2A\u0E48\u0E07",
  cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"
};

const tr = {
  step_up_authentication: "G\xFCvenlik Do\u011Frulama",
  this_operation_is_at_risk_and_requires_authentication: "Bu i\u015Flem risklidir ve g\xFCvenlik do\u011Frulamas\u0131 gerekmektedir",
  please_enter_the_answer: "L\xFCtfen cevab\u0131 giriniz",
  refresh: "Yenile",
  submit: "G\xF6nder",
  cancel: "\u0130ptal"
};

const vi = {
  step_up_authentication: "X\xE1c th\u1EF1c an to\xE0n",
  this_operation_is_at_risk_and_requires_authentication: "Thao t\xE1c n\xE0y c\xF3 r\u1EE7i ro v\xE0 c\u1EA7n ph\u1EA3i \u0111\u01B0\u1EE3c x\xE1c th\u1EF1c an to\xE0n",
  please_enter_the_answer: "Vui l\xF2ng nh\u1EADp c\xE2u tr\u1EA3 l\u1EDDi",
  refresh: "L\xE0m m\u1EDBi",
  submit: "G\u1EEDi",
  cancel: "H\u1EE7y"
};

const zhHans = {
  step_up_authentication: "\u5B89\u5168\u9A8C\u8BC1",
  this_operation_is_at_risk_and_requires_authentication: "\u672C\u6B21\u64CD\u4F5C\u6709\u98CE\u9669,\u9700\u8981\u8FDB\u884C\u5B89\u5168\u9A8C\u8BC1",
  please_enter_the_answer: "\u8BF7\u8F93\u5165\u7B54\u6848",
  refresh: "\u5237\u65B0",
  submit: "\u63D0\u4EA4",
  cancel: "\u53D6\u6D88"
};

const zhHant = {
  step_up_authentication: "\u5B89\u5168\u9A8C\u8BC1",
  this_operation_is_at_risk_and_requires_authentication: "\u672C\u6B21\u64CD\u4F5C\u6709\u98CE\u9669,\u9700\u8981\u8FDB\u884C\u5B89\u5168\u9A8C\u8BC1",
  please_enter_the_answer: "\u8BF7\u8F93\u5165\u7B54\u6848",
  refresh: "\u5237\u65B0",
  submit: "\u63D0\u4EA4",
  cancel: "\u53D6\u6D88"
};

var __async$8 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const VerifyDialog = defineComponent({
  name: "VerifyDialog",
  props: {
    languageCode: { required: true, type: String },
    show: { required: true, type: Boolean },
    captchaData: { required: true, type: String },
    captchaTips: { required: true, type: String },
    captchaId: { required: true, type: String },
    close: { required: true, type: Function },
    confirm: { required: true, type: Function }
  },
  setup(props) {
    var _a;
    const translatorText = { en, ar, de, es, fr, id, ja, ko, pt, ru, th, tr, vi, zhHans, zhHant };
    const textObj = (_a = translatorText[props.languageCode.replace("-", "")]) != null ? _a : translatorText.en;
    const captchaObj = reactive({
      inputText: "",
      show: props.show,
      captchaData: props.captchaData,
      captchaTips: props.captchaTips,
      captchaId: props.captchaId
    });
    function handleClose() {
      captchaObj.show = false;
      props.close();
    }
    function handleConfirm() {
      return __async$8(this, null, function* () {
        if (!captchaObj.inputText)
          return;
        yield props.confirm({ captchaId: captchaObj.captchaId, captchaData: captchaObj.inputText });
      });
    }
    function reloadCaptcha() {
      return __async$8(this, null, function* () {
        const res = yield sdkRefreshCaptcha({ captchaId: captchaObj.captchaId });
        captchaObj.captchaData = res.captchaData;
        captchaObj.captchaTips = res.captchaTips;
        captchaObj.captchaId = res.captchaId;
      });
    }
    return () => {
      var _a2, _b;
      return captchaObj.show && h("div", { class: "fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-70 z-1000 flex justify-center items-center" }, [
        h("div", { class: "w-full max-w-320px bg-white rounded-12px pt-22px overflow-hidden relative" }, [
          h("div", {
            class: "i-ic:round-close text-24px text-#999999 absolute right-10px top-10px cursor-pointer",
            onClick: handleClose,
            on: {
              click: handleClose
            }
          }),
          h(
            "p",
            { class: "text-center text-#212121 text-20px leading-20px m-0 mb-20px" },
            textObj.step_up_authentication
          ),
          h("div", { class: "w-full box-border px-16px" }, [
            h(
              "p",
              { class: "text-14px text-#333 m-0 mb-4px leading-21px" },
              textObj.this_operation_is_at_risk_and_requires_authentication
            ),
            h(
              "p",
              { class: "text-#666 text-12px leading-18px m-0 mb-15px" },
              textObj.please_enter_the_answer
            ),
            h("div", { class: "flex items-center h-35px flex-wrap mb-30px" }, [
              h(
                "input",
                {
                  type: "text",
                  class: "block w-110px h-full outline-none border-none box-border border-0.5px border-solid border-[rgba(0,0,0,0.20)] rounded-3.5px text-12px p-0 px-8px placeholder-#999 mr-6px text-#333",
                  placeholder: (_a2 = props.captchaTips) != null ? _a2 : "\u8F93\u5165\u6570\u5B57\u6216\u5B57\u6BCD",
                  value: captchaObj.inputText,
                  attrs: {
                    type: "text",
                    placeholder: (_b = props.captchaTips) != null ? _b : "\u8F93\u5165\u6570\u5B57\u6216\u5B57\u6BCD",
                    value: captchaObj.inputText
                  },
                  on: {
                    input: (e) => {
                      captchaObj.inputText = e.target.value;
                    }
                  },
                  onInput: (e) => {
                    captchaObj.inputText = e.target.value;
                  }
                }
              ),
              h("div", { class: "w-105px h-full mr-14px" }, [
                captchaObj.captchaData && h("img", {
                  src: `data:image/jpeg;base64,${captchaObj.captchaData}`,
                  class: "w-full h-full",
                  attrs: {
                    src: `data:image/jpeg;base64,${captchaObj.captchaData}`
                  }
                })
              ]),
              h("div", {
                class: "text-#009DE4 text-12px flex items-center cursor-pointer",
                onClick: reloadCaptcha,
                on: {
                  click: reloadCaptcha
                }
              }, [
                h("div", { class: "i-ic:baseline-refresh text-16px mr-2px" }),
                h("p", textObj.refresh)
              ])
            ])
          ]),
          h("div", { class: "flex h-44px text-16px" }, [
            h("div", {
              class: "flex-1 w-full text-white border-t border-r border-solid border-t-[rgba(0,0,0,0.15)] border-r-[rgba(0,0,0,0.15)] flex items-center justify-center cursor-pointer box-border outline-none",
              onClick: handleConfirm,
              on: {
                click: handleConfirm
              }
            }, [h("p", { class: "text-#FE9129 m-0" }, textObj.submit)]),
            h("div", {
              class: "flex-1 text-white flex items-center justify-center border-t border-solid border-t-[rgba(0,0,0,0.15)] cursor-pointer box-border outline-none",
              onClick: handleClose,
              on: {
                click: handleClose
              }
            }, [h("p", { class: "text-#666 m-0" }, textObj.cancel)])
          ])
        ])
        // h(Transition, {
        //   'enter-active-class': 'duration-300 ease-out',
        //   'leave-active-class': 'duration-300 ease-in',
        //   'enter-from-class': 'transform opacity-0',
        //   'leave-to-class': 'transform opacity-0',
        // }, {
        //   default: () => unref(errorMessage) && h(
        //     'div',
        //     { class: 'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-8px bg-black bg-opacity-70 text-white h-40px px-2 flex justify-center items-center text-14px' },
        //     unref(errorMessage),
        //   ),
        // }),
      ]);
    };
  }
});

var __async$7 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function createVerifyDialog(params) {
  const VERIFY_ID = "ld-sdk-verify-dialog";
  const hasElement = document.getElementById(VERIFY_ID);
  if (hasElement)
    return;
  const parent = document.createElement("div");
  parent.id = VERIFY_ID;
  const el = document.createElement("style");
  el.id = `${VERIFY_ID}-style`;
  el.innerHTML = VerifyDialogStyle;
  parent.appendChild(el);
  document.body.appendChild(parent);
  const instance = createApp(VerifyDialog, {
    show: params.show,
    captchaData: params.captchaData,
    captchaTips: params.captchaTips,
    captchaId: params.captchaId,
    languageCode: params.languageCode,
    close() {
      var _a2;
      (_a2 = params.close) == null ? void 0 : _a2.call(params);
      instance.unmount();
      document.body.removeChild(parent);
    },
    confirm(data) {
      return __async$7(this, null, function* () {
        var _a2;
        yield (_a2 = params.confirm) == null ? void 0 : _a2.call(params, data);
        instance.unmount();
        document.body.removeChild(parent);
      });
    }
  });
  let mountNode = parent;
  const realRenderEl = document.createElement("div");
  parent.appendChild(realRenderEl);
  mountNode = realRenderEl;
  instance.mount(mountNode);
}

function getAgeFromIdCard(identityCard) {
  const len = `${identityCard}`.length;
  let strBirthday = "";
  if (len === 18)
    strBirthday = `${identityCard.substr(6, 4)}/${identityCard.substr(10, 2)}/${identityCard.substr(12, 2)}`;
  if (len === 15) {
    let birthdayValue = "";
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
    if (Number.parseInt(birthdayValue) < 10)
      strBirthday = `20${identityCard.substr(6, 2)}/${identityCard.substr(8, 2)}/${identityCard.substr(10, 2)}`;
    else
      strBirthday = `19${identityCard.substr(6, 2)}/${identityCard.substr(8, 2)}/${identityCard.substr(10, 2)}`;
  }
  const birthDate = new Date(strBirthday);
  const nowDateTime = /* @__PURE__ */ new Date();
  let age = nowDateTime.getFullYear() - birthDate.getFullYear();
  if (nowDateTime.getMonth() < birthDate.getMonth() || nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
    age--;
  return age;
}
function md5(str, removeQuotesMd5 = false) {
  return MD5(removeQuotesMd5 ? `${str}` : `"${str}"`);
}
function getOriginUrl(url) {
  const regex = /^https?:\/\/[^/]+/i;
  const match = url.match(regex);
  const baseUrl = match ? match[0] : "";
  return baseUrl;
}
function createIframe(params) {
  let width = "100%";
  let height = "100%";
  const iframe = document.createElement("iframe");
  iframe.src = params.url;
  iframe.style.cssText = `position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:${width};height:${height};z-index:9999999;background:transparent;display:none;`;
  function changeIframeSize(params2) {
    width = params2.width;
    height = params2.height;
  }
  function showIframe(status) {
    if (status)
      iframe.style.cssText = `position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:${width};height:${height};z-index:9999999;background:transparent;display:block;`;
    else
      iframe.remove();
  }
  return { iframe, changeIframeSize, showIframe };
}

const version = "0.0.35-beta.3";

let storage = void 0;
function getStorage() {
  if (!storage) {
    storage = createStorage({
      driver: localStorageDriver({ base: "LDSDK:" })
    });
  }
  return storage;
}

var __defProp$6 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __async$6 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var IframeEvent = /* @__PURE__ */ ((IframeEvent2) => {
  IframeEvent2["RESIZEVIEW"] = "ld-web-sdk_resizeView";
  IframeEvent2["CLOSEANDTRANSMIT"] = "ld-web-sdk_closeAndTransmit";
  IframeEvent2["CLOSEVIEW"] = "ld-web-sdk_closeView";
  return IframeEvent2;
})(IframeEvent || {});
const match = version.match(/^(\d+\.\d+\.\d+)/);
const headersParams = {
  protocol_version: "1",
  sdk_version: match ? match[1] : "0.0.1",
  sdk_platform: "WEB",
  app_id: "",
  ext_app_id: "",
  channel_id: "",
  sub_channel_id: "",
  device_id: "",
  request_id: "",
  timestamp: "",
  language_code: "",
  sign: ""
};
const requestConfig = {
  code: "",
  secreKey: "",
  userApi: "",
  payApi: ""
};
const commomParams = {
  gameId: 0,
  robotCheck: false
};
function updateConfig({ develop, region, code, secreKey, devurl }) {
  requestConfig.code = code != null ? code : "";
  if (region === "domestic") {
    requestConfig.secreKey = secreKey || (develop ? "b762fe5224ac88ec6d86aa02d8edc37c" : "b762fe5224ac88ec6d86aa02d8edc37c");
    requestConfig.userApi = devurl || (develop ? "http://139.196.167.20:8556" : "https://cz-platform.ldmnq.com");
    requestConfig.payApi = develop ? "http://sdktestpay.ldmnq.com" : "https://paysdk.ldmnq.com";
  } else if (region === "oversea") {
    requestConfig.secreKey = secreKey || (develop ? "cbe324bcbd1663f709079baf25ed640d" : "cbe324bcbd1663f709079baf25ed640d");
    requestConfig.userApi = devurl || (develop ? "https://test-overseas-usercenter.ldmnq.com" : "https://usersdk.ldmnq.com");
    requestConfig.payApi = develop ? "https://test-overseas-paycenter.ldmnq.com" : "https://paysdk.ldmnq.com";
  }
}
const SID = "SID";
function setComParams(params) {
  return __async$6(this, null, function* () {
    const storage = getStorage();
    const sid = yield storage.getItem(SID);
    headersParams.device_id = `web,web,web,web${sid ? `,${sid}` : ",web"}`;
    headersParams.app_id = params.appId;
    headersParams.channel_id = params.channelId;
    headersParams.sub_channel_id = params.subChannelId;
    headersParams.language_code = params.languageCode;
    headersParams.ext_app_id = params.extAppId;
    params.gameId && (commomParams.gameId = params.gameId);
    params.robotCheck && (commomParams.robotCheck = params.robotCheck);
    updateConfig(params);
  });
}
function getHeadersParams() {
  return Object.assign(__spreadProps$4(__spreadValues$6({}, headersParams), { request_id: v1(), timestamp: dayjs().format("YYYYMMDDHHmmss") }));
}
function getConfig() {
  return Object.assign(__spreadValues$6({}, requestConfig));
}

var __defProp$5 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __async$5 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const instance = axios.create();
instance.interceptors.request.use((config) => {
  const { secreKey } = getConfig();
  const headersParams = getHeadersParams();
  const { optionsHeaders = {} } = config;
  const bodyParams = (config == null ? void 0 : config.data) ? config.data : {};
  const fingerprint = MD5(`${headersParams.protocol_version}+${headersParams.sdk_version}+${headersParams.app_id}+${headersParams.timestamp}+${headersParams.request_id}+${headersParams.device_id}+${secreKey}`).toUpperCase();
  const sign = MD5(`${JSON.stringify(bodyParams)}+${fingerprint}+${secreKey}`).toUpperCase();
  const headers = __spreadProps$3(__spreadValues$5(__spreadValues$5({ "Content-Type": "application/json" }, headersParams), optionsHeaders), { sign });
  if (config.headers.captcha_data && config.headers.captcha_id) {
    headers.captcha_id = config.headers.captcha_id;
    headers.captcha_data = config.headers.captcha_data;
  }
  return __spreadProps$3(__spreadValues$5({}, config), {
    headers,
    data: bodyParams
  });
}, (error) => {
  return Promise.reject(error);
});
instance.interceptors.response.use((config) => {
  var _a, _b;
  const { status, data } = config;
  const { isDomestic } = config.config || {};
  if (status !== 200)
    return Promise.reject(data);
  if (data.code !== 200)
    return Promise.reject(data);
  if (isDomestic) {
    return (_a = config.data) != null ? _a : null;
  }
  return (_b = config.data.data) != null ? _b : null;
}, (error) => {
  return Promise.reject(error);
});
function requestAxios(url, config) {
  return __async$5(this, null, function* () {
    return new Promise((reslove, reject) => {
      instance(url, config).then((res) => reslove(res)).catch((error) => {
        const headersParams = getHeadersParams();
        if (!commomParams.robotCheck) {
          reject(error);
          return;
        }
        const data = error != null ? error : {};
        if (data.code === 1001 && data.data.captchaType === 1) {
          createVerifyDialog({
            show: true,
            captchaData: data.data.captchaData,
            captchaTips: data.data.captchaTips,
            captchaId: data.data.captchaId,
            languageCode: headersParams.language_code,
            confirm(data2) {
              return __async$5(this, null, function* () {
                const headers = {};
                if (data2.captchaId && data2.captchaData) {
                  headers.captcha_id = data2.captchaId;
                  headers.captcha_data = data2.captchaData;
                }
                yield instance(url, __spreadProps$3(__spreadValues$5({}, config), { headers: __spreadValues$5({}, headers) })).then((res) => {
                  reslove(res);
                }).catch((err) => {
                  reject(err);
                });
              });
            },
            close() {
              reject(error);
            }
          });
        } else if (data.code === 1001 && data.data.captchaType === 2) {
          const curUrl = data.data.captchaData;
          const baseUrl = getOriginUrl(curUrl);
          console.log(baseUrl);
          const { captchaId } = data.data;
          const { iframe, showIframe, changeIframeSize } = createIframe({ url: curUrl });
          window.addEventListener("message", (event) => __async$5(this, null, function* () {
            if (event.origin === baseUrl) {
              const { type } = event.data;
              if (type === IframeEvent.CLOSEVIEW) {
                showIframe(false);
                reject(error);
              } else if (type === IframeEvent.RESIZEVIEW) {
                const { data: data2 } = event.data;
                changeIframeSize({ width: data2.width, height: data2.height });
                showIframe(true);
              } else if (type === IframeEvent.CLOSEANDTRANSMIT) {
                const { data: res } = event.data;
                const headers = {};
                if (res.answer) {
                  headers.captcha_id = captchaId;
                  headers.captcha_data = res.answer;
                }
                showIframe(false);
                yield instance(url, __spreadProps$3(__spreadValues$5({}, config), { headers: __spreadValues$5({}, headers) })).then((res2) => reslove(res2)).catch((err) => reject(err));
              }
            }
          }), false);
          document.body.appendChild(iframe);
        } else {
          reject(error);
        }
      });
    });
  });
}
function baseHttp(url, options) {
  return __async$5(this, null, function* () {
    const config = getConfig();
    return requestAxios(url, __spreadValues$5({ baseURL: config.userApi }, options));
  });
}
function loginHttp(url, options) {
  return __async$5(this, null, function* () {
    const config = getConfig();
    return requestAxios(url, __spreadValues$5({ baseURL: config.userApi }, options));
  });
}
function payHttp(url, options) {
  return __async$5(this, null, function* () {
    const config = getConfig();
    return requestAxios(url, __spreadValues$5({ baseURL: config.payApi }, options));
  });
}
function domesticHttp(requestParams, options) {
  return __async$5(this, null, function* () {
    const config = getConfig();
    if (options.headers) {
      options.optionsHeaders = options.headers;
      delete options.headers;
    }
    return requestAxios(requestParams, __spreadProps$3(__spreadValues$5({ baseURL: config.userApi }, options), { isDomestic: true }));
  });
}

function sdkRefreshCaptcha(params) {
  return baseHttp("/sdk/refreshCaptcha" /* REFRESH_CAPTCHA */, {
    method: "post",
    data: params
  });
}
function sdkTest1001(params) {
  return baseHttp("/sdk/test1001" /* SKD_TEST1001 */, {
    method: "post",
    data: params
  });
}
function sdkTest1002() {
  return baseHttp("/sdk/test1002" /* SKD_TEST1002 */, {
    method: "post"
  });
}
function initSdk() {
  return baseHttp("/sdk/initSdk" /* INITSDK */, {
    method: "post"
  });
}

var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function initLdSdk(params) {
  return __async$4(this, null, function* () {
    const initParams = defu(params, { channelId: "10100", subChannelId: "10101" });
    yield setComParams(initParams);
    const storage = getStorage();
    const sid = yield storage.getItem(SID);
    if (!sid) {
      const res = yield initSdk();
      yield storage.setItem(SID, res.sid);
      yield setComParams(initParams);
    }
  });
}
function resizeView(params) {
  var _a, _b, _c;
  if (window.webkit || params.type === "ios")
    (_b = (_a = window.webkit) == null ? void 0 : _a.messageHandlers) == null ? void 0 : _b.resizeView.postMessage(JSON.stringify({ width: params.width, height: params.height }));
  else if (window.Android || params.type === "android")
    (_c = window.Android) == null ? void 0 : _c.resizeView(params.width, params.height);
  else
    window.parent.postMessage({ type: IframeEvent.RESIZEVIEW, data: { width: params.width, height: params.height } }, "*");
}
function closeView(type) {
  var _a, _b, _c;
  if (window.webkit || type === "ios")
    (_b = (_a = window.webkit) == null ? void 0 : _a.messageHandlers) == null ? void 0 : _b.closeView.postMessage("");
  else if (window.Android || type === "android")
    (_c = window.Android) == null ? void 0 : _c.closeView();
  else
    window.parent.postMessage({ type: IframeEvent.CLOSEVIEW }, "*");
}
function closeAndTransmit(answer, type) {
  var _a, _b, _c;
  if (window.webkit || type === "ios")
    (_b = (_a = window.webkit) == null ? void 0 : _a.messageHandlers) == null ? void 0 : _b.closeAndTransmit.postMessage(answer);
  else if (window.Android || type === "android")
    (_c = window.Android) == null ? void 0 : _c.closeAndTransmit(answer);
  else
    window.parent.postMessage({ type: IframeEvent.CLOSEANDTRANSMIT, data: { answer } }, "*");
}
function test1002() {
  return sdkTest1002();
}
function test1001(params) {
  return sdkTest1001({ captchaType: params.captchaType, captchaData: params == null ? void 0 : params.captchaData, captchaId: params == null ? void 0 : params.captchaId });
}
function getBCP47byLanguageCode(locale) {
  const localeMap = {
    zh: "zh-Hans",
    tw: "zh-Hant",
    en: "en",
    jp: "ja",
    kr: "ko",
    th: "th",
    id: "id",
    vn: "vi",
    fr: "fr",
    ru: "ru",
    ar: "ar",
    de: "de",
    es: "es",
    // pt和br都是pt
    pt: "pt",
    br: "pt"
  };
  return !locale ? "GB" : localeMap[locale];
}

var __defProp$4 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const storageName$1 = "SDK-INFO";
function userGetUserInfo(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/getUserInfo" /* USER_GETUSERINFO */, { method: "post", data: params });
  });
}
function userChangeEmail(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/changeEmail" /* USER_CHANGEEMAIL */, { method: "post", data: params });
  });
}
function userUpdateUserBasicInfo(params) {
  return loginHttp("/user/updateUserBasicInfo" /* USER_UPDATEUSERBASICINFO */, { method: "post", data: params });
}
function userBindUser(params) {
  return loginHttp("/user/bindUser" /* USER_BINDUSER */, { method: "post", data: params });
}
function userVerifyMailVerifyCode(params) {
  return loginHttp("/user/verifyEmailVerifyCode" /* USER_VERIFYEMAILVERIFYCODE */, { method: "post", data: params });
}
function userGetPcBindUser(params) {
  return loginHttp("/user/getPcBindUser" /* USER_GETPCBINDUSER */, { method: "post", data: params });
}
function userGetBindTypes(params) {
  return loginHttp("/user/getBindTypes" /* USER_GETBINDTYPES */, { method: "post", data: params });
}
function userUpdateUser(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/updateUser" /* USER_UPDATEUSER */, { method: "post", data: params });
  });
}
function userPcLogin(params) {
  return __async$3(this, null, function* () {
    const storage = getStorage();
    const res = yield loginHttp("/user/pcLogin" /* USER_PCLOGIN */, { method: "post", data: params });
    res && (yield storage.setItem(storageName$1, res));
    return res;
  });
}
function userInitSdk(params) {
  return loginHttp("/user/initSdk" /* USER_INITSDK */, { method: "post", data: __spreadProps$2(__spreadValues$4({}, params), { appType: 2 }) });
}
function userCancelOut(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/cancelOut" /* USER_CANCELOUT */, { method: "post", data: params });
  });
}
function userLogout$1(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/logout" /* USER_LOGOUT */, { method: "post", data: params });
  });
}
function userSendSms$1(params) {
  return loginHttp("/user/sendSms" /* USER_SENDSMS */, { method: "post", data: params });
}
function userSendEmail(params) {
  return loginHttp("/user/sendEmail" /* USER_SENDEMAIL */, { method: "post", data: params });
}
function userLogin$1(params) {
  return __async$3(this, null, function* () {
    return loginHttp("/user/login" /* USER_LOGIN */, { method: "post", data: params });
  });
}

var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getUserInfoByTokenAndUid(params) {
  const { app_id: appId } = getHeadersParams();
  return userGetUserInfo(__spreadValues$3({ appId }, params));
}
function getUserInfo() {
  return __async$2(this, null, function* () {
    const loginInfo = yield getLoginInfo$1();
    return getUserInfoByTokenAndUid(loginInfo);
  });
}
function getComParams$1(params) {
  var _a;
  const { app_id: appId, device_id: mid, channel_id: mainChannelId, sub_channel_id: subChannelId } = getHeadersParams();
  const { code } = getConfig();
  return {
    appId,
    mid,
    mainChannelId,
    subChannelId,
    phoneBrand: params.phoneBrand,
    phoneModel: params.phoneModel,
    timeZone: params.timeZone,
    operator: params.operator,
    code,
    isCoolingOffPeriod: (_a = params.isCoolingOffPeriod) != null ? _a : false
  };
}
function changeEmail(params) {
  return __async$2(this, null, function* () {
    const loginInfo = yield getLoginInfo$1();
    const { app_id: appId } = getHeadersParams();
    const storage = getStorage();
    const res = yield userChangeEmail(__spreadValues$3({ appId, token: loginInfo.token, uid: loginInfo.uid }, params));
    yield storage.removeItem(storageName$1);
    return res;
  });
}
function createLogin$1(config = { removeQuotesMd5: false }) {
  const storage = getStorage();
  function google(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "GOOGLE",
        auth: params.auth
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function facebook(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "FACEBOOK",
        auth: params.auth
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function apple(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "APPLE",
        auth: params.auth
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function mildom(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "MILDOM",
        auth: params.auth
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function line(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "LINE",
        auth: params.auth
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function email(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "EMAIL",
        auth: params.auth,
        email: params.email,
        pwd: md5(`${params.pwd}`, config == null ? void 0 : config.removeQuotesMd5)
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function phone(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "PHONE",
        auth: params.auth,
        phone: params.phone,
        countryCode: params.countryCode,
        pwd: md5(`${params.pwd}`, config == null ? void 0 : config.removeQuotesMd5)
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function phoneWithPwd(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "USERNAME",
        auth: md5(`${params.auth}`, config == null ? void 0 : config.removeQuotesMd5),
        phone: params.phone,
        countryCode: params.countryCode
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function emailWithPwd(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "USERNAME",
        auth: md5(`${params.auth}`, config == null ? void 0 : config.removeQuotesMd5),
        email: params.email
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function userNameWithPwd(params) {
    return __async$2(this, null, function* () {
      const apiParams = __spreadValues$3({
        loginMode: "USERNAME",
        auth: md5(`${params.auth}`, config == null ? void 0 : config.removeQuotesMd5),
        userName: params.username
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  function auto() {
    return __async$2(this, arguments, function* (params = {}) {
      const loginInfo = yield getLoginInfo$1();
      if (!loginInfo)
        throw new Error("\u767B\u9646\u5931\u8D25");
      const apiParams = __spreadValues$3({
        loginMode: "AUTO",
        auth: loginInfo.token,
        userId: loginInfo.uid
      }, getComParams$1(params));
      const res = yield userLogin$1(apiParams);
      yield storage.setItem(storageName$1, res);
      return res;
    });
  }
  return {
    email,
    phone,
    phoneWithPwd,
    emailWithPwd,
    userNameWithPwd,
    google,
    facebook,
    line,
    apple,
    mildom,
    auto
  };
}
function getLoginInfo$1() {
  const storage = getStorage();
  return storage.getItem(storageName$1);
}
function setLoginInfo(params) {
  const storage = getStorage();
  return storage.setItem(storageName$1, params);
}
function clearLoginInfo() {
  const storage = getStorage();
  return storage.clear(storageName$1);
}
function sendEmail(params) {
  const { app_id: appId } = getHeadersParams();
  return userSendEmail(__spreadProps$1(__spreadValues$3({}, params), { appId }));
}
function sendSms$1(params) {
  const { app_id: appId } = getHeadersParams();
  return userSendSms$1(__spreadProps$1(__spreadValues$3({}, params), { appId }));
}
function logout$1() {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    const params = yield getLoginInfo$1();
    if (!params)
      return true;
    const storage = getStorage();
    const res = yield userLogout$1({ token: params.token, uid: params.uid, appId });
    yield storage.removeItem(storageName$1);
    return res;
  });
}
function cancelOut() {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    const { code } = getConfig();
    const loginInfo = yield getLoginInfo$1();
    if (!loginInfo)
      return true;
    const storage = getStorage();
    const res = yield userCancelOut({ appId, token: loginInfo.token, uid: loginInfo.uid, code });
    yield storage.removeItem(storageName$1);
    return res;
  });
}
function initSdkOpt() {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    return userInitSdk({ appId });
  });
}
function pcLogin() {
  const { app_id: appId } = getHeadersParams();
  return userInitSdk({ appId });
}
function createUpdateUser$1(config = { removeQuotesMd5: false }) {
  const { app_id: appId } = getHeadersParams();
  function emailUpdate(params) {
    return __async$2(this, null, function* () {
      const storage = getStorage();
      const res = yield userUpdateUser(__spreadProps$1(__spreadValues$3({}, params), { appId, auth: params.auth, pwd: md5(`${params.pwd}`, config == null ? void 0 : config.removeQuotesMd5) }));
      yield storage.removeItem(storageName$1);
      return res;
    });
  }
  function phoneUpdate(params) {
    return __async$2(this, null, function* () {
      const storage = getStorage();
      const res = userUpdateUser(__spreadProps$1(__spreadValues$3({}, params), { appId, auth: params.auth, pwd: md5(`${params.pwd}`, config == null ? void 0 : config.removeQuotesMd5) }));
      yield storage.removeItem(storageName$1);
      return res;
    });
  }
  return { emailUpdate, phoneUpdate };
}
function getBindTypes() {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    const loginInfo = yield getLoginInfo$1();
    return userGetBindTypes({ appId, userId: loginInfo == null ? void 0 : loginInfo.uid });
  });
}
function getPcBindUser() {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    const { code } = getConfig();
    return userGetPcBindUser({ appId, code });
  });
}
function verifyEmailVerifyCode(params) {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    return userVerifyMailVerifyCode(__spreadValues$3({ appId }, params));
  });
}
function createBindUser() {
  return __async$2(this, null, function* () {
    const { app_id: appId, device_id: userId } = getHeadersParams();
    const { code } = getConfig();
    const comParams = { appId, code, userId };
    function emailBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "EMAIL" }, comParams), params);
      return userBindUser(apiParams);
    }
    function lineBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "LINE" }, comParams), params);
      return userBindUser(apiParams);
    }
    function appleBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "APPLE" }, comParams), params);
      return userBindUser(apiParams);
    }
    function googleBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "GOOGLE" }, comParams), params);
      return userBindUser(apiParams);
    }
    function facebookBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "FACEBOOK" }, comParams), params);
      return userBindUser(apiParams);
    }
    function phoneBind(params) {
      const apiParams = __spreadValues$3(__spreadValues$3({ loginMode: "PLONE" }, comParams), params);
      return userBindUser(apiParams);
    }
    return { emailBind, lineBind, appleBind, googleBind, facebookBind, phoneBind };
  });
}
function refreshCaptcha(params) {
  return sdkRefreshCaptcha(params);
}
function updateUserBasicInfo(params) {
  return __async$2(this, null, function* () {
    const { app_id: appId } = getHeadersParams();
    const loginInfo = yield getLoginInfo$1();
    return userUpdateUserBasicInfo(__spreadProps$1(__spreadValues$3({}, params), { appId, token: loginInfo.token, uid: loginInfo.uid }));
  });
}

const login = {
  __proto__: null,
  cancelOut: cancelOut,
  changeEmail: changeEmail,
  clearLoginInfo: clearLoginInfo,
  createBindUser: createBindUser,
  createLogin: createLogin$1,
  createUpdateUser: createUpdateUser$1,
  getBindTypes: getBindTypes,
  getLoginInfo: getLoginInfo$1,
  getPcBindUser: getPcBindUser,
  getUserInfo: getUserInfo,
  getUserInfoByTokenAndUid: getUserInfoByTokenAndUid,
  initSdkOpt: initSdkOpt,
  logout: logout$1,
  pcLogin: pcLogin,
  refreshCaptcha: refreshCaptcha,
  sendEmail: sendEmail,
  sendSms: sendSms$1,
  setLoginInfo: setLoginInfo,
  updateUserBasicInfo: updateUserBasicInfo,
  userPcLogin: userPcLogin,
  verifyEmailVerifyCode: verifyEmailVerifyCode
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
function payInitConfig() {
  return payHttp("/open/pay/init/config" /* PAY_INIT_CONFIG */, { method: "post" });
}
function createTpOrder(params) {
  const { app_id } = getHeadersParams();
  const data = __spreadValues$2({ appId: app_id }, params);
  return payHttp("/client/pay/other/create" /* CREATE_TP_ORDER */, { method: "post", data });
}
function payOrderInitPage(params) {
  return payHttp("/client/pay/order/init-page" /* PAY_ORDER_INIT */, { method: "post", data: params });
}
function getPayGradesByQuery(params) {
  return payHttp("/client/pay/grades/query" /* GRADES_QUERY */, { method: "post", data: params });
}
function getExchangeByCustomPrice(params) {
  return payHttp("/client/pay/exchange/query" /* EXCHANGE_QUERY */, { method: "post", data: params });
}
function getPayChannelByCustomPrice(params) {
  return payHttp("/client/pay/channels/query" /* CHANNELS_QUERY */, { method: "post", data: params });
}

const pay = {
  __proto__: null,
  createTpOrder: createTpOrder,
  getExchangeByCustomPrice: getExchangeByCustomPrice,
  getPayChannelByCustomPrice: getPayChannelByCustomPrice,
  getPayGradesByQuery: getPayGradesByQuery,
  payInitConfig: payInitConfig,
  payOrderInitPage: payOrderInitPage
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const storageName = "login-info";
function clearSdkInfo() {
  return __async$1(this, null, function* () {
    const storage = getStorage();
    const has = yield storage.hasItem(storageName);
    if (!has)
      return true;
    return storage.removeItem(storageName);
  });
}
function updateSdkInfo(info) {
  return __async$1(this, null, function* () {
    try {
      const storage = getStorage();
      const storageInfo = (yield storage.getItem(storageName)) || {};
      Object.keys(info).forEach((key) => {
        storageInfo[key] = info[key];
      });
      yield storage.setItem(storageName, storageInfo);
    } catch (error) {
      throw new Error(error.message, { cause: error });
    }
  });
}
function userLogin(params, options) {
  return __async$1(this, null, function* () {
    try {
      const storage = getStorage();
      const res = yield domesticHttp("/user/login" /* USER_LOGIN */, __spreadValues$1({ method: "post", data: params }, options));
      yield storage.setItem(storageName, res.data);
      return res;
    } catch (error) {
      clearSdkInfo();
      throw new Error(error.message, { cause: error });
    }
  });
}
function userDesertedLogin4Game(params, options) {
  return __async$1(this, null, function* () {
    try {
      const storage = getStorage();
      const res = yield domesticHttp("/user/login4Game" /* USER_DESERTEDLOGIN */, __spreadValues$1({ method: "post", data: params }, options));
      yield storage.setItem(storageName, res.data);
      return res;
    } catch (error) {
      clearSdkInfo();
      throw new Error(error.message, { cause: error });
    }
  });
}
function userLoginTo(params, options) {
  return __async$1(this, null, function* () {
    try {
      const storage = getStorage();
      const res = yield domesticHttp("/user/loginTo" /* USER_LOGINTO */, __spreadValues$1({ method: "post", data: params }, options));
      yield storage.setItem(storageName, res.data);
      return res;
    } catch (error) {
      clearSdkInfo();
      throw new Error(error.message, { cause: error });
    }
  });
}
function userRegister(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/regUser" /* USER_REGISTER */, __spreadValues$1({ method: "post", data: params }, options));
    return res;
  });
}
function userSendSms(params, options) {
  return domesticHttp("/user/sendSms" /* USER_SENDSMS */, __spreadValues$1({ method: "post", data: params }, options));
}
function userVerifySendSms(params, options) {
  return domesticHttp("/user/verifySms" /* USER_VERIFYSMS */, __spreadValues$1({ method: "post", data: params }, options));
}
function userModifyPwd(params, options) {
  return __async$1(this, null, function* () {
    try {
      const res = yield domesticHttp("/user/modifyPwd" /* USER_MODIFYPWD */, __spreadValues$1({ method: "post", data: params }, options));
      clearSdkInfo();
      return res;
    } catch (error) {
      throw new Error(error.message, { cause: error });
    }
  });
}
function userForgetPwd(params, options) {
  return __async$1(this, null, function* () {
    const res = domesticHttp("/user/forgetPwd" /* USER_FORGETPWD */, __spreadValues$1({ method: "post", data: params }, options));
    yield clearSdkInfo();
    return res;
  });
}
function userLogout(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/loginout" /* USER_LOGOUT */, __spreadValues$1({ method: "post", data: params }, options));
    yield clearSdkInfo();
    return res;
  });
}
function userTovoid(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/tovoidUser" /* USER_TOVOID */, __spreadValues$1({ method: "post", data: params }, options));
    yield clearSdkInfo();
    return res;
  });
}
function userBindPhone(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/bindPhone" /* USER_BINDPHONE */, __spreadValues$1({ method: "post", data: params }, options));
    updateSdkInfo({
      isbindphone: 1,
      phone: params.phone
    });
    return res;
  });
}
function userModifyPhone(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/modifyPhone" /* USER_MODIFYPHONE */, __spreadValues$1({ method: "post", data: params }, options));
    updateSdkInfo({
      phone: params.phone
    });
    return res;
  });
}
function userVerifyIdCard(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/verifyIDcard" /* USER_VERIFYIDCARD */, __spreadValues$1({ method: "post", data: params }, options));
    const age = getAgeFromIdCard(params.cardId);
    updateSdkInfo({
      age,
      cardID: params.cardId,
      isadult: Number(age >= 18),
      realname: params.realName
    });
    return res;
  });
}
function userModifyInfo(params, options) {
  return __async$1(this, null, function* () {
    const res = yield domesticHttp("/user/modifyUser" /* USER_MODIFYINFO */, __spreadValues$1({ method: "post", data: params }, options));
    updateSdkInfo({
      portraiturl: params.portraitUrl,
      nickname: params.nickName
    });
    return res;
  });
}
function userLoginQRCode(params, options) {
  return domesticHttp("/user/loginQRcode" /* USER_LOGINQRCODE */, __spreadValues$1({ method: "post", data: params }, options));
}
function userUnbindQqWx(params, options) {
  return __async$1(this, null, function* () {
    const storage = getStorage();
    const res = yield domesticHttp("/user/unBindQqWx" /* USER_UNBINDQQWX */, __spreadValues$1({ method: "post", data: params }, options));
    const { isbindwxqq = 0 } = (yield storage.getItem(storageName)) || { isbindwxqq: 0 };
    let bind = 0;
    switch (isbindwxqq) {
      case 1:
      case 2:
        bind = 0;
        break;
      case 3:
        bind = params.bindType === "WX" ? 2 : 1;
        break;
    }
    updateSdkInfo({
      isbindwxqq: bind
    });
    return res;
  });
}
function userBindQqWx(params, options) {
  return __async$1(this, null, function* () {
    const storage = getStorage();
    const res = yield domesticHttp("/user/bindWxQq" /* USER_BINDQQWX */, __spreadValues$1({ method: "post", data: params }, options));
    const { isbindwxqq = 0 } = (yield storage.getItem(storageName)) || { isbindwxqq: 0 };
    let bind = isbindwxqq;
    switch (isbindwxqq) {
      case 1:
      case 2:
        bind = 3;
        break;
      case 0:
        bind = params.bindType === "WX" ? 1 : 2;
        break;
    }
    updateSdkInfo({
      isbindwxqq: bind
    });
    return res;
  });
}
function userCheckThirdAccount(params, options) {
  return domesticHttp("/user/checkThirdAccount" /* USER_CHECKTHIRDACCOUNT */, __spreadValues$1({ method: "post", data: params }, options));
}
function userDesertedCheckWechat(params, options) {
  return domesticHttp("/user/checkWechat" /* USER_DESERTEDCHECKWECHAT */, __spreadValues$1({ method: "post", data: params }, options));
}
function userDesertedBindWechat(params, options) {
  return __async$1(this, null, function* () {
    const storage = getStorage();
    const res = yield domesticHttp("/user/bindWechat" /* USER_DESERTEDBINDWECHAT */, __spreadValues$1({ method: "post", data: params }, options));
    const { isbindwxqq = 0 } = (yield storage.getItem(storageName)) || { isbindwxqq: 0 };
    updateSdkInfo({
      isbindwxqq: isbindwxqq === 0 ? 1 : 3
    });
    return res;
  });
}
function userDelTrustDevice(params, options) {
  return domesticHttp("/user/delTrustDevice" /* USER_DELTRUSTDEVICE */, __spreadValues$1({ method: "post", data: params }, options));
}
function userGetTrustDevice(params, options) {
  return domesticHttp("/user/getTrustDevice" /* USER_GETTRUSTDEVICE */, __spreadValues$1({ method: "post", data: params }, options));
}
function userUnfreezeRisk(params, options) {
  return domesticHttp("/user/unfreezeRisk" /* USER_UNFREEZERISK */, __spreadValues$1({ method: "post", data: params }, options));
}
function userDesertedInitGame(params, options) {
  return domesticHttp("/user/initGame" /* USER_DESERTEDINITGAME */, __spreadValues$1({ method: "post", data: params }, options));
}
function userGenerateUsername(params, options) {
  return domesticHttp("/user/generateUsername" /* USER_GENERATEUSERNAME */, __spreadValues$1({ method: "post", data: params }, options));
}
function userGetServerTime(params, options) {
  return domesticHttp("/user/getServerTime" /* USER_GETSERVERTIME */, __spreadValues$1({ method: "post", data: params }, options));
}
function userGetTicket(params, options) {
  return domesticHttp("/user/getTicket" /* USER_GETTICKET */, __spreadValues$1({ method: "post", data: params }, options));
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getLoginInfo() {
  const storage = getStorage();
  return storage.getItem("login-info");
}
function getComParams(params) {
  const { app_id: appId, device_id: deviceId, channel_id: channelId, sub_channel_id: subChannelId, sdk_version: sv } = getHeadersParams();
  const { openId, isAdServing, deviceMac, deviceOaid, deviceUuid, deviceImei, deviceAndroid, deviceBrand, deviceModel } = params;
  const { gameId } = commomParams;
  return {
    appId,
    deviceId: params.deviceId || deviceId,
    channelId,
    subChannelId,
    sv,
    gameId,
    openId,
    isAdServing,
    deviceMac,
    deviceOaid,
    deviceUuid,
    deviceImei,
    deviceAndroid,
    deviceBrand,
    deviceModel
  };
}
function createLogin() {
  return {
    phone(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadValues({
          loginMode: "phone",
          auth: params.auth,
          phone: params.phone,
          newPwd: MD5(`${params.newPwd}`),
          portraitUrl: params.portraitUrl,
          nickName: params.nickName
        }, getComParams(params));
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    userNameWithPwd(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadValues({
          loginMode: "username",
          auth: MD5(`${params.auth}`),
          userName: params.userName
        }, getComParams(params));
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    auto() {
      return __async(this, arguments, function* (params = {}, options = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u767B\u9646\u5931\u8D25");
        const apiParams = __spreadValues({
          loginMode: "auto",
          auth: loginInfo.token,
          uid: loginInfo.uid
        }, getComParams(params));
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    qrcode(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "qrcode"
        }, getComParams(params)), {
          auth: params.auth
        });
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    douyin(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "douyin"
        }, getComParams(params)), {
          auth: params.auth
        });
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    qq(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "qq"
        }, getComParams(params)), {
          outOpenId: params.outOpenId,
          bindPhone: params.bindPhone,
          bindPhoneAuth: params.bindPhoneAuth,
          nickName: params.nickName,
          portraitUrl: params.portraitUrl
        });
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    wechat(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "wechat"
        }, getComParams(params)), {
          bindPhone: params.bindPhone,
          bindPhoneAuth: params.bindPhoneAuth,
          appId: params.appId,
          auth: params.auth
        });
        const res = yield userLogin(apiParams, options);
        return res;
      });
    },
    loginTo(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const apiParams = __spreadProps(__spreadValues({}, getComParams(params)), {
          targetGameId: params.targetGameId,
          uid: loginInfo.uid,
          token: loginInfo.token
        });
        !params.openId && (apiParams.openId = "999");
        const res = yield userLoginTo(apiParams, options);
        return res;
      });
    }
  };
}
function createDesertedLogin4Game() {
  return {
    phone(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadValues({
          loginMode: "phone",
          auth: params.auth,
          phone: params.phone,
          newPwd: MD5(`${params.newPwd}`),
          portraitUrl: params.portraitUrl,
          nickName: params.nickName
        }, getComParams(params));
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    },
    userNameWithPwd(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadValues({
          loginMode: "username",
          auth: MD5(`${params.auth}`),
          userName: params.userName
        }, getComParams(params));
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    },
    auto() {
      return __async(this, arguments, function* (params = {}, options = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u767B\u9646\u5931\u8D25");
        const apiParams = __spreadValues({
          loginMode: "auto",
          auth: loginInfo.token,
          uid: loginInfo.uid
        }, getComParams(params));
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    },
    qrcode(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "qrcode"
        }, getComParams(params)), {
          auth: params.auth
        });
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    },
    qq(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "qq"
        }, getComParams(params)), {
          outOpenId: params.outOpenId,
          bindPhone: params.bindPhone,
          bindPhoneAuth: params.bindPhoneAuth,
          nickName: params.nickName,
          portraitUrl: params.portraitUrl
        });
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    },
    wechat(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const apiParams = __spreadProps(__spreadValues({
          loginMode: "wechat"
        }, getComParams(params)), {
          bindPhone: params.bindPhone,
          bindPhoneAuth: params.bindPhoneAuth,
          appId: params.appId,
          auth: params.auth
        });
        const res = yield userDesertedLogin4Game(apiParams, options);
        return res;
      });
    }
  };
}
function registerByUsername(_0) {
  return __async(this, arguments, function* (params, options = {}) {
    return userRegister(__spreadProps(__spreadValues({}, getComParams(params)), { userName: params.userName, auth: MD5(`${params.auth}`), openId: params.openId }), options);
  });
}
function sendSms(_0) {
  return __async(this, arguments, function* (params, options = {}) {
    if (params.smsType && ["modifyphone"].includes(params.smsType)) {
      const loginInfo = yield getLoginInfo();
      if (!loginInfo)
        throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
      return userSendSms(__spreadProps(__spreadValues({}, params), { gameId: commomParams.gameId, uid: loginInfo.uid }), options);
    }
    return userSendSms(__spreadProps(__spreadValues({}, params), { gameId: commomParams.gameId }), options);
  });
}
function logout() {
  return __async(this, arguments, function* (options = {}) {
    const { device_id: deviceId } = getHeadersParams();
    const params = yield getLoginInfo();
    if (!params)
      return true;
    return userLogout({ gameId: commomParams.gameId, token: params.token, uid: params.uid, deviceId }, options);
  });
}
function createModifyPwd(options = {}) {
  return {
    phone(params) {
      return __async(this, null, function* () {
        const { device_id: deviceId, channel_id: channelId, sub_channel_id: subChannelId } = getHeadersParams();
        const res = yield userForgetPwd(__spreadProps(__spreadValues({
          gameId: commomParams.gameId,
          deviceId,
          channelId,
          subChannelId
        }, params), {
          newPwd: MD5(`${params.newPwd}`)
        }), options);
        return res;
      });
    },
    password(_0) {
      return __async(this, arguments, function* (params, options2 = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userModifyPwd({
          gameId: commomParams.gameId,
          deviceId,
          uid: loginInfo.uid,
          token: loginInfo.token,
          oldPwd: MD5(`${params.oldPwd}`),
          newPwd: MD5(`${params.newPwd}`)
        }, options2);
        return res;
      });
    }
  };
}
function createUpdateUser(options = {}) {
  return {
    bindPhone(params) {
      return __async(this, null, function* () {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userBindPhone(__spreadValues({
          gameId: commomParams.gameId,
          uid: loginInfo.uid
        }, params), options);
        return res;
      });
    },
    modifyPhone(_0) {
      return __async(this, arguments, function* (params, options2 = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userModifyPhone(__spreadValues({
          gameId: commomParams.gameId,
          deviceId,
          uid: loginInfo.uid,
          token: loginInfo.token,
          phone: loginInfo.phone
        }, params), options2);
        return res;
      });
    },
    verifyIDcard(_0) {
      return __async(this, arguments, function* (params, options2 = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userVerifyIdCard(__spreadValues({
          gameId: commomParams.gameId,
          uid: loginInfo.uid
        }, params), options2);
        return res;
      });
    },
    modifyUserInfo(_0) {
      return __async(this, arguments, function* (params, options2 = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userModifyInfo(__spreadValues({
          gameId: commomParams.gameId,
          deviceId,
          uid: loginInfo.uid,
          token: loginInfo.token
        }, params), options2);
        return res;
      });
    }
  };
}
function createLoginQrcode() {
  return __async(this, arguments, function* (options = {}) {
    const res = yield userLoginQRCode({
      gameId: commomParams.gameId
    }, options);
    return res;
  });
}
function tovoidUser() {
  return __async(this, arguments, function* (options = {}) {
    const { device_id: deviceId } = getHeadersParams();
    const loginInfo = yield getLoginInfo();
    if (!loginInfo)
      throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
    return userTovoid({ gameId: commomParams.gameId, token: loginInfo.token, uid: loginInfo.uid, deviceId }, options);
  });
}
function createThirdPart() {
  return {
    unbindQqWx(_0) {
      return __async(this, arguments, function* (bindType, options = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userUnbindQqWx({
          gameId: commomParams.gameId,
          uid: loginInfo.uid,
          deviceId,
          token: loginInfo.token,
          bindType
        }, options);
        return res;
      });
    },
    bindQQ(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userBindQqWx(__spreadValues({
          gameId: commomParams.gameId,
          uid: loginInfo.uid,
          deviceId,
          token: loginInfo.token,
          bindType: "QQ"
        }, params), options);
        return res;
      });
    },
    bindWechat(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const { device_id: deviceId } = getHeadersParams();
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userBindQqWx(__spreadValues({
          gameId: commomParams.gameId,
          uid: loginInfo.uid,
          deviceId,
          token: loginInfo.token,
          bindType: "WX"
        }, params), options);
        return res;
      });
    },
    webCheckQQAccount(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userCheckThirdAccount(__spreadValues({
          gameId: commomParams.gameId,
          outUserType: "QQ"
        }, params), options);
        return res;
      });
    },
    androidCheckQQAccount(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userCheckThirdAccount(__spreadValues({
          gameId: commomParams.gameId,
          outUserType: "QQ"
        }, params), options);
        return res;
      });
    },
    checkWechatAccount(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userCheckThirdAccount(__spreadValues({
          gameId: commomParams.gameId,
          outUserType: "WX"
        }, params), options);
        return res;
      });
    },
    checkDouYinAccount(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userCheckThirdAccount(__spreadValues({
          gameId: commomParams.gameId,
          outUserType: "DY"
        }, params), options);
        return res;
      });
    },
    desertedCheckWechat(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userDesertedCheckWechat(__spreadValues({
          gameId: commomParams.gameId
        }, params), options);
        return res;
      });
    },
    desertedBindWechat(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const res = yield userDesertedBindWechat(__spreadValues({
          gameId: commomParams.gameId
        }, params), options);
        return res;
      });
    }
  };
}
function getTrustDevice() {
  return __async(this, arguments, function* (options = {}) {
    const loginInfo = yield getLoginInfo();
    if (!loginInfo)
      throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
    return userGetTrustDevice({ gameId: commomParams.gameId, uid: loginInfo.uid }, options);
  });
}
function delTrustDevice(_0) {
  return __async(this, arguments, function* (params, options = {}) {
    const loginInfo = yield getLoginInfo();
    if (!loginInfo)
      throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
    return userDelTrustDevice(__spreadValues({ gameId: commomParams.gameId, uid: loginInfo.uid }, params), options);
  });
}
function createUnFreezeRisk() {
  return {
    byPaymentNumberAndPhone(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        if (!loginInfo.phone)
          throw new Error("\u6B64\u8D26\u53F7\u4ECD\u672A\u7ED1\u5B9A\u624B\u673A\u53F7");
        const res = yield userUnfreezeRisk(__spreadProps(__spreadValues({
          gameId: commomParams.gameId
        }, params), {
          newPwd: MD5(`${params.newPwd}`),
          validateType: 1,
          accountIdentifyType: 1
        }), options);
        return res;
      });
    },
    byPaymentNumberAndUid(_0) {
      return __async(this, arguments, function* (params, options = {}) {
        const loginInfo = yield getLoginInfo();
        if (!loginInfo)
          throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
        const res = yield userUnfreezeRisk(__spreadProps(__spreadValues({
          gameId: commomParams.gameId
        }, params), {
          newPwd: MD5(`${params.newPwd}`),
          validateType: 1,
          accountIdentifyType: 2,
          uid: loginInfo.uid
        }), options);
        return res;
      });
    }
  };
}
function desertedInitGame(_0) {
  return __async(this, arguments, function* (params, options = {}) {
    const loginInfo = yield getLoginInfo();
    if (!loginInfo)
      throw new Error("\u83B7\u53D6\u767B\u5F55\u4FE1\u606F\u5931\u8D25");
    const { device_id: deviceId, channel_id: channelId, sub_channel_id: subChannelId } = getHeadersParams();
    return userDesertedInitGame(__spreadValues({ gameId: commomParams.gameId, deviceId, channelId, subChannelId }, params), options);
  });
}
function verifySendSms(_0) {
  return __async(this, arguments, function* (params, options = {}) {
    const { device_id: deviceId } = getHeadersParams();
    return userVerifySendSms(__spreadProps(__spreadValues({}, params), {
      deviceId,
      gameId: commomParams.gameId
    }), options);
  });
}
function generateUsername() {
  return __async(this, arguments, function* (options = {}) {
    const { device_id: deviceId } = getHeadersParams();
    return userGenerateUsername({
      deviceId,
      gameId: commomParams.gameId
    }, options);
  });
}
function getServerTime() {
  return __async(this, arguments, function* (options = {}) {
    const { device_id: deviceId } = getHeadersParams();
    return userGetServerTime({
      deviceId,
      gameId: commomParams.gameId
    }, options);
  });
}
function getTicket(_0) {
  return __async(this, arguments, function* (appId, options = {}) {
    return userGetTicket({
      appId,
      gameId: commomParams.gameId
    }, options);
  });
}

const userCenter = {
  __proto__: null,
  createDesertedLogin4Game: createDesertedLogin4Game,
  createLogin: createLogin,
  createLoginQrcode: createLoginQrcode,
  createModifyPwd: createModifyPwd,
  createThirdPart: createThirdPart,
  createUnFreezeRisk: createUnFreezeRisk,
  createUpdateUser: createUpdateUser,
  delTrustDevice: delTrustDevice,
  desertedInitGame: desertedInitGame,
  generateUsername: generateUsername,
  getLoginInfo: getLoginInfo,
  getServerTime: getServerTime,
  getTicket: getTicket,
  getTrustDevice: getTrustDevice,
  logout: logout,
  registerByUsername: registerByUsername,
  sendSms: sendSms,
  tovoidUser: tovoidUser,
  verifySendSms: verifySendSms
};

export { closeAndTransmit, closeView, userCenter as domesticUserCenter, getBCP47byLanguageCode, initLdSdk, login as overseaLogin, pay as overseaPay, resizeView, test1001, test1002 };
